import * as React from 'react';
import { isNil } from 'lodash';
import classnames from 'classnames';

import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import EntityName from 'components/entity/entity-name/EntityName';

import { renderPrice } from 'utils/helper/price';
import { getEntityFromProfile } from 'utils/view';
import { getTotalVariablePayment } from 'utils/payouts';

import './campaign-payouts-header-info.scss';

import type { BrandProfile, PaymentInfo, SubcampaignInfluencerProfile } from 'types';

type Profile = BrandProfile | SubcampaignInfluencerProfile;

type Props = {
  profile: Profile | undefined | null,
  paymentInfo: PaymentInfo,
  otherArrangement?: boolean,
  isBrand: boolean
};

class CampaignPayoutsHeaderInfo extends React.PureComponent<Props> {
  static defaultProps = {
    isBrand: false
  };

  renderAvatar(): React.ReactNode {
    const { profile, isBrand } = this.props;
    const entity = getEntityFromProfile(profile);
    const entityUrl = isBrand ?
      `/content-creator/profiles/${entity?.id}` :
      `/brand/profiles/${entity?.id}`;

    return (
      <EntityAvatar
        bordered
        entity={entity}
        link={entityUrl}
        customSize={{ width: 64, height: 64 }}
        openInNewTab
      />
    );
  }

  renderName(): React.ReactNode {
    const { profile, isBrand } = this.props;
    const entity = getEntityFromProfile(profile);
    const entityUrl = isBrand ?
      `/content-creator/profiles/${entity?.id}` :
      `/brand/profiles/${entity?.id}`;

    return (
      <EntityName
        entity={entity}
        link={entityUrl}
        size="large"
        openInNewTab
      />
    );
  }

  renderTotalPayment(): React.ReactNode {
    const { paymentInfo, otherArrangement } = this.props;
    const variablePayment = getTotalVariablePayment(paymentInfo);

    return (
      <div
        className="campaign-payouts-header-info__total-payment"
        title={`${paymentInfo.label} ${paymentInfo.value}`}
      >
        <div className="campaign-payouts-header-info__payout-label">
          {paymentInfo.label}
        </div>
        <div>
          {
            otherArrangement ?
              renderPrice(variablePayment, { defaultValue: String(paymentInfo.value) })
              : paymentInfo.value
          }
        </div>
      </div>
    );
  }

  render(): React.ReactNode {
    const { isBrand, profile } = this.props;

    if (isNil(profile)) {
      return null;
    }

    const classes = classnames('campaign-payouts-header-info', {
      'campaign-payouts-header-info--type-influencer': !isBrand
    });

    return (
      <div
        className={classes}
        data-qa="campaign-payouts-header-info"
      >
        <div className="campaign-payouts-header-info__avatar">
          {this.renderAvatar()}
        </div>
        <div className="campaign-payouts-header-info__details">
          {this.renderName()}
          {this.renderTotalPayment()}
        </div>
      </div>
    );
  }
}

export default CampaignPayoutsHeaderInfo;
